import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ItemList from '../../Item-List';
import { useKanban } from 'hooks/useKanban';

const Objective = ({
  id,
  name: initialName,
  setItems,
  index,
  isNew,
  setSelectedItem,
  setIsOpenModalDelete,
  setStatus,
}) => {
  const { kanban: paidMedia } = useKanban();
  const [name, setName] = useState(initialName);

  const addObjective = async () => {
    const response = await paidMedia.createTypeItem('objectives', { name });

    return {
      id: response.id,
      name,
      isNew: false,
    };
  };

  const updateObjective = async () => {
    return await paidMedia.updateTypeItem('objectives', id, {
      id,
      name,
    });
  };

  return (
    <ItemList
      id={id}
      initialName={initialName}
      name={name}
      setName={setName}
      setItems={setItems}
      index={index}
      isNew={isNew}
      setSelectedItem={setSelectedItem}
      setIsOpenModalDelete={setIsOpenModalDelete}
      setStatus={setStatus}
      addItem={addObjective}
      updateItem={updateObjective}
      textSaveButton="Add objective"
    />
  );
};

Objective.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
  setItems: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  accountParam: PropTypes.string.isRequired,
  isNew: PropTypes.bool,
  setSelectedItem: PropTypes.func.isRequired,
  setIsOpenModalDelete: PropTypes.func.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default Objective;
